import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './../guards/auth.guard';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
const default_route = 'home';
const routes: Routes = [
  { path: '', redirectTo: default_route, pathMatch: 'full' },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/home/home.module').then((m) => m.HomeModule)
      },
      {
        path: 'worker-home',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/worker/worker.module').then((m) => m.WorkerModule)
      },
      {
        path: 'customer-home',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./pages/customers/customer.module').then(
            (m) => m.CustomerModule
          )
      },
      {
        path: 'offer/:idSeo',
        loadChildren: () =>
          import('./pages/offer-detail/offer-detail.module').then(
            (m) => m.OfferDetailModule
          )
      },
      {
        path: 'services',
        loadChildren: () =>
          import('./pages/services/service.module').then((m) => m.ServiceModule)
      },
      {
        path: 'payment/result',
        loadChildren: () =>
          import('./pages/payment-result/payment-result.module').then(
            (m) => m.PaymentResultModule
          )
      },
      {
        path: 'client-register',
        loadChildren: () =>
          import('./pages/client-register/client-register.module').then(
            (r) => r.ClientRegisterModule
          )
      }
    ]
  },
  {
    path: 'register',
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/register/register.module').then(
            (m) => m.RegisterModule
          )
      }
    ]
  },
  {
    path: 'email',
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/email/email.module').then((m) => m.EmailModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {}
